// src/intake/IntakeProgress.tsx
// ─────────────────────────────────────────────────────────────────────────────
// Brief 23 — Thin progress bar with percentage text
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';

interface IntakeProgressProps {
  current: number;
  total: number;
}

export default function IntakeProgress({ current, total }: IntakeProgressProps) {
  const pct = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 160 }}>
      <div
        style={{
          flex: 1,
          height: 4,
          borderRadius: 2,
          background: 'rgba(255,255,255,0.15)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: '100%',
            borderRadius: 2,
            background: '#64DAD2',
            transition: 'width 300ms ease',
          }}
        />
      </div>
      <span style={{ color: '#fff', fontSize: 13, whiteSpace: 'nowrap', fontFamily: "'Montserrat', sans-serif" }}>
        {pct}% complete
      </span>
    </div>
  );
}
